import React, { useEffect, useState } from "react";
import logopng from "../../../assets/NewLogo2.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useUserContext } from "../../../context/MemorialContext";
import { updateHasPaid } from "./utils";
import "../about/about.css";

function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const [purchaseType, setPurchaseType] = useState(null);

  const { user, setUser, fetchUser } = useUserContext();

  // Leer tipo de compra desde la URL (FIRST_PLAN_PURCHASE, PLAN_UPGRADE, FRAME_ONLY)
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("purchaseType");
    const plan = searchParams.get("plan");

    if (type) {
      setPurchaseType(type);
    }

    // Mantener compatibilidad con flujos antiguos basados en `package`
    if (!type && searchParams.get("package")) {
      setPurchaseType("FIRST_PLAN_PURCHASE");
    }

    if (plan) {
      localStorage.setItem("package", plan);
    }
  }, [location.search]);

  // Actualiza usuario después del pago
  useEffect(() => {
    if (user) {
      updateHasPaid(user, true, setUser);
      fetchUser();
    }
  }, []);

  const handleContinue = async () => {
    // Comportamiento según tipo de compra
    if (purchaseType === "PLAN_UPGRADE" || purchaseType === "FRAME_ONLY") {
      navigate("/mymemo");
      return;
    }

    // FIRST_PLAN_PURCHASE u otros casos por defecto → flujo de creación de memorial
    navigate("/creatememorial");
  };

  return (
    <div className="aboutpage">
      <div className="ab-top">
        <img
          src={logopng}
          style={{ maxWidth: "300px", minWidth: "200px" }}
          alt="Logo"
        />
        <div className="content1">
          <p className="tp">Payment Successful</p>
          <p className="btm">
            At willalwaysloveu, we provide a shared, easily-accessible virtual space where family members and friends can pay homage to a special life while helping each other heal by sharing their feelings, warm memories, and words of support.
          </p>

          <div className="addressWrapper">
            <button className="memobtn" onClick={handleContinue}>
              {purchaseType === "PLAN_UPGRADE"
                ? "View my memorial"
                : purchaseType === "FRAME_ONLY"
                ? "Go to my memorials"
                : "Create memorial"}
            </button>
          </div>
        </div>
      </div>

      <div className="triagnle"></div>
      <div className="ab-bottom"></div>
    </div>
  );
}

export default Success;

